/**
 * Build the `silentCheckSsoRedirectUri` passed to `keycloak.init` on web.
 *
 * Pure (origin + router basename in, URL string out) so it is unit-testable.
 * The caller supplies `location.origin` and the build-time
 * `VITE_ROUTER_BASENAME` (read via `environment.ts`, which Jest's CommonJS
 * runtime cannot parse because of `import.meta`).
 */
export function buildSilentCheckSsoRedirectUri(
  origin: string,
  basename: string | undefined
): string {
  // Strip leading/trailing slashes so a basename like "/partner" does not
  // produce a double slash ("origin//partner/..."). No-op for the default
  // empty basename and for bare names like "partner".
  const normalized = basename ? basename.replace(/^\/+|\/+$/g, "") : "";
  const prefix = normalized ? `${normalized}/` : "";
  return `${origin}/${prefix}silent-check-sso.html`;
}
